import React from "react";
import { useI18n } from "../i18n";

const stats = [
  { value: "500+", key: "stats.businesses" },
  { value: "1M+", key: "stats.messages" },
  { value: "99.9%", key: "stats.uptime" },
  { value: "4.8/5", key: "stats.satisfaction" },
];

export function Stats() {
  const { t } = useI18n();

  return (
    <section className="py-16 px-6 border-y border-[#2a2040]" style={{ background: "linear-gradient(180deg, #0a0a12 0%, #14121e 50%, #0a0a12 100%)" }}>
      <div className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-8">
        {stats.map((stat, i) => (
          <div key={stat.key} className="text-center onyx-stat-item">
            <div className="text-3xl md:text-4xl font-bold onyx-gradient-text onyx-title mb-2">
              {stat.value}
            </div>
            <div className="text-sm text-[#8a7a9a]">
              {t(stat.key)}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
